// This function uses Interaction Observer to detect if an Antd Select is open
// When it is open, it sets a loop looking for the antd select option, and adds a class when it is active

let isKeyboardNavigation = false;
let intervalId = null;

function handleKeyDown(e) {
    const navKeys = ['ArrowDown', 'ArrowUp', 'Tab'];
    if (navKeys.includes(e.key)) {
        isKeyboardNavigation = true;
    }
}

function handleFocusIn(e) {
    // If focus is inside a dropdown and it came via keyboard, enable highlighting
    const dropdown = e.target.closest('.ant-select-dropdown');
    if (dropdown) {
        isKeyboardNavigation = true;
    }
}

function handleMouseMove() {
    isKeyboardNavigation = false;
}

function isVisibleDropdown(el) {
    return el && !el.hasAttribute('hidden') && el.offsetParent !== null;
}

function applyFocusedClass() {
    const dropdowns = Array.from(document.querySelectorAll('.ant-select-dropdown'));
    const visibleDropdown = dropdowns.find(isVisibleDropdown);

    if (!visibleDropdown) {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
        return;
    }

    const activeOption = visibleDropdown.querySelector('.ant-select-item-option-active');
    const allOptions = visibleDropdown.querySelectorAll('.ant-select-item-option');

    allOptions.forEach((opt) => opt.classList.remove('focused'));

    if (activeOption && isKeyboardNavigation) {
        activeOption.classList.add('focused');
    }
}

function watchDropdownVisibility() {
    const check = () => {
        const dropdowns = Array.from(document.querySelectorAll('.ant-select-dropdown'));
        const anyVisible = dropdowns.some(isVisibleDropdown);

        if (anyVisible && !intervalId) {
            intervalId = setInterval(applyFocusedClass, 100);
        } else if (!anyVisible && intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
    };

    const visibilityWatcherId = setInterval(check, 100);

    return () => {
        clearInterval(visibilityWatcherId);
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
    };
}

export function setupAntdSelectOptionFocusHandler() {
    window.addEventListener('keydown', handleKeyDown, true);
    window.addEventListener('mousemove', handleMouseMove, true);
    window.addEventListener('focusin', handleFocusIn, true);

    const stopWatching = watchDropdownVisibility();

    return () => {
        window.removeEventListener('keydown', handleKeyDown, true);
        window.removeEventListener('mousemove', handleMouseMove, true);
        window.removeEventListener('focusin', handleFocusIn, true);
        stopWatching();
    };
}
